<template>
  <header :class="fadeClasses">
    <p>En dat begint heel simpel.</p>
    <h3 class="title">Wie ben jij? Kies je leeftijd en geslacht.</h3>
  </header>
</template>

<script>
import { fadeMixin } from '@/mixins'

export default {
  name: 'ChoiceHeader',
  mixins: [fadeMixin]
}
</script>

<style lang="scss" scoped>
.title {
  color: $c-red;
  font-size: $fs-heading;
  line-height: $lh-heading;
  font-weight: $fw-bold;
}
</style>
